import { Input } from "antd";
import axios from "axios";
import { useState } from "react";
import { toast } from "react-toastify";

import { AddToPlayListModalStyle } from "../../components/AddToPlayListModal/AddToPlayListModal.style";
import Spinner from "../../components/Spinner/Spinner";
import { useLoginContext } from "../../context";

interface CreatePlayListModalProps {
  isModalVisible?: boolean;
  setIsModalVisible?: (_: boolean) => void;
  playlists?: any;
  setPlaylists?: any;
}

const CreatePlayListModal = (props: CreatePlayListModalProps) => {
  const { isModalVisible, setIsModalVisible } = props;
  const [setLoading, showLoading] = useState(false);
  const { state: loginState } = useLoginContext();

  const [data, setData] = useState({
    name: "",
    description: "",
    public: false,
  });

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = (e: any) => {
    e.stopPropagation();
    setIsModalVisible(false);
  };

  const handleFormSubmit = (values: any) => {
    if (values.name !== "" || values.description !== "") {
      showLoading(true);
      axios
        .post(
          `https://api.spotify.com/v1/me/playlists`,
          JSON.stringify(data),
          {
            headers: {
              Authorization: `Bearer ${loginState.token}`,
            },
          }
        )
        .then((res) => {
          toast.success("Playlist created successfully");
          showLoading(false);
          setIsModalVisible(false);
          window.location.reload();
        })
        .catch((e) => {
          toast.error("Error while creating playlist");
          showLoading(false);
        });
    }
  };

  return (
    <AddToPlayListModalStyle
      visible={isModalVisible}
      onOk={handleOk}
      footer={null}
      onCancel={handleCancel}
    >
      <div className="addToPlaylistHead" style={{ paddingBottom: "0px" }}>
        <h1 className="heading">Create playlist</h1>
      </div>
      <div className="formAddToPlaylist">
        <div className="formPlaylist">
          <div className="playlistPosition">
            <label className="label">
              <p>Playlist name</p>
              <Input
                placeholder="Playlist name"
                onChange={(value) => {
                  let obj = { ...data };
                  obj.name = value.target.value;
                  setData(obj);
                }}
                value={data.name || ""}
                maxLength={100}
              />
            </label>
          </div>
          <label className="label">
            <p>Description</p>
            <Input.TextArea
              className="addNoteText"
              placeholder="Description"
              rows={4}
              onChange={(value: any) => {
                let obj = { ...data };
                obj.description = value.target.value;
                setData(obj);
              }}
              value={data?.description || ""}
              maxLength={300}
            />
          </label>
          <p className="textarea_count">
            {data?.description?.length || "0"} / 300
          </p>
        </div>
      </div>
      <div className="buttonDiv">
        <button
          className="addSong"
          disabled={setLoading}
          onClick={() => handleFormSubmit(data)}
        >
          {setLoading ? <Spinner /> : "Add"}
        </button>
      </div>
    </AddToPlayListModalStyle>
  );
};

export default CreatePlayListModal;
